/**
 * Font families available to the app.
 *
 * Each family must also be requested in the Google Fonts <link> in
 * public/index.html, otherwise it silently falls back to a system font.
 * Loaded weights: Lato 300/400/700/900, Manrope 200-800, Noto Sans 100-900.
 */
export const fonts = {
  manrope: "Manrope",
  inter: "Inter",
  lato: "Lato",
  notoSans: "Noto Sans",
};
